import React from 'react';
import { AlgoliaHitTransformer } from '../../Algolia/transformers/AlgoliaHitTransformer';
import { ProgressiveImage } from '../../hooks/useProgressiveImage/useProgressiveImage';
import { styles } from './ProductInformationCard.css';
import { MarkdownBlock } from '../../MarkdownBlock';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';
import {
  MarketplaceSellerCallout,
  MarketplaceSellerCalloutProps,
} from '../../Marketplace/MarketplaceSellerCallout/MarketplaceSellerCallout';
import { ProductImageFallback } from '../../ProductImageFallback/ProductImageFallback';

export type TrackingProduct = {
  sku: string;
  imageUrl: string;
  name: string;
  isBackOrder?: boolean;
};

export type TrackingProductAlert = {
  type: 'Info' | 'Error';
  content: string;
};

export type ProductInformationProps = {
  product: TrackingProduct;
  marketplaceSeller?: Omit<MarketplaceSellerCalloutProps, 'className' | 'testId'>;
  note?: string;
  alert?: TrackingProductAlert;
};

export const ProductInformationCard = ({ product, marketplaceSeller, note, alert }: ProductInformationProps) => {
  return (
    <div data-test-id="order-tracking-product-information">
      <div className={styles.productWrapper}>
        {product.imageUrl ? (
          <ProgressiveImage
            className={styles.productImage}
            {...AlgoliaHitTransformer.toProgressiveImageProps({
              product_image: product.imageUrl,
              title: product.name,
            })}
          />
        ) : (
          <ProductImageFallback className={styles.productImage} />
        )}
        <div className={styles.text}>
          {product.name}
          {marketplaceSeller ? (
            <MarketplaceSellerCallout
              marketplaceCallout={marketplaceSeller.marketplaceCallout}
              sellerName={marketplaceSeller.sellerName}
            />
          ) : null}
          {note ? <span className={styles.note}>{note}</span> : null}
          {alert ? (
            <div className={styles.alert({ type: alert.type })}>
              <Icon name={alert.type} />
              <MarkdownBlock className={styles.alert({ type: alert.type })}>{alert.content}</MarkdownBlock>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
